module.exports = __webpack_public_path__ + "static/media/E6.e8e0ccfe.jpeg";